import React from 'react'
import { Link } from 'react-router-dom'

const TermsAndConditions = () => {
  return (
    <section className="section-one">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <p>
              Welcome to our homemade products e-commerce platform. These Terms and Conditions govern your use of our platform and the purchase of homemade products.
              By accessing or using our platform, you agree to comply with these Terms and Conditions. If you do not agree with any part of these terms, please do not use our platform.
            </p>

            <h5>1. Use of Platform:</h5>
            <ul>
              <li><strong>1.1 License:</strong> We grant you a limited, non-exclusive, revocable license to access and use our platform for the purpose of purchasing homemade products.</li>
              <li><strong>1.2 Account Creation:</strong> You may be required to create an account to access certain features of our platform. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</li>
              <li><strong>1.3 Prohibited Activities:</strong> You agree not to engage in any activities that violate these Terms and Conditions or any applicable laws, including but not limited to:
                <ul>
                  <li>Using our platform for any unlawful purpose.</li>
                  <li>Impersonating any person or entity.</li>
                  <li>Interfering with the proper functioning of our platform.</li>
                  <li>Attempting to gain unauthorized access to any part of our platform.</li>
                </ul>
              </li>
            </ul>

            <h5>2. Purchases and Transactions:</h5>
            <ul>
              <li><strong>2.1 Product Listings:</strong> We strive to provide accurate and up-to-date information about our homemade products, including descriptions, prices, and availability. However, we do not guarantee the accuracy or completeness of this information.</li>
              <li><strong>2.2 Order Acceptance:</strong> Your submission of an order constitutes an offer to purchase the products listed in your order. We reserve the right to accept or reject your order for any reason, including but not limited to product availability, errors in pricing or product descriptions, or suspicion of fraudulent activity.</li>
              <li><strong>2.3 Payment:</strong> You agree to pay the total amount due for your order, including any applicable taxes and shipping fees. Payment must be made using one of the accepted payment methods specified on our platform.</li>
              <li><strong>2.4 Shipping and Delivery:</strong> We will make reasonable efforts to ship your order in a timely manner and to deliver it to the address specified during checkout. However, we do not guarantee delivery dates and are not responsible for delays caused by shipping carriers or other factors beyond our control.</li>
            </ul>

            <h5>3. Intellectual Property:</h5>
            <ul>
              <li><strong>3.1 Ownership:</strong> All content, logos, trademarks, and other intellectual property displayed on our platform are the property of Rastelx Technologies Private Limited or its licensors and are protected by copyright, trademark, and other laws.</li>
              <li><strong>3.2 License:</strong> We grant you a limited, non-exclusive license to use our intellectual property solely for the purpose of accessing and using our platform in accordance with these Terms and Conditions.</li>
            </ul>

            <h5>4. Limitation of Liability:</h5>
            <ul>
              <li><strong>4.1 Disclaimer:</strong> To the fullest extent permitted by law, we disclaim all warranties, express or implied, regarding the operation of our platform and the homemade products sold on it. We are not responsible for any damages or losses resulting from your use of our platform or your purchase of homemade products.</li>
              <li><strong>4.2 Limitation of Liability:</strong> In no event shall Village Zone or its affiliates be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with these Terms and Conditions or your use of our platform.</li>
            </ul>

            <h5>5. Indemnification:</h5>
            <p>
              You agree to indemnify and hold harmless Village Zone and its affiliates from any claims, damages, losses, or expenses arising out of or in connection with your use of our platform, your violation of these Terms and Conditions, or your violation of any rights of third parties.
            </p>

            <h5>6. Governing Law:</h5>
            <p>
              These Terms and Conditions shall be governed by and construed in accordance with the laws of the Government of India, without regard to its conflict of laws principles.
            </p>

            <h5>7. Changes to Terms and Conditions:</h5>
            <p>
              We reserve the right to update or modify these Terms and Conditions at any time without prior notice. Any changes will be effective immediately upon posting on our platform. Your continued use of our platform after the posting of changes constitutes your acceptance of the revised Terms and Conditions.
            </p>

            <h5>8. Contact Us:</h5>
            <p>
              If you have any questions or concerns about these Terms and Conditions, please contact us at <a href="mailto:info@rastelx.com">info@rastelx.com</a>.
            </p>

            <p>
              By using our e-commerce platform, you acknowledge that you have read, understood, and agreed to the terms of these Terms and Conditions.
            </p>

            <p><strong>This policy is effective as of 2024-05-10</strong></p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TermsAndConditions